import React from 'react';
import Description from 'components/typography/Description';

const AdditionalDataInputDescription = () => {
  return (
    <Description>
      Complete any <b>additional</b> information that you think is relevant.
    </Description>
  );
};

export default AdditionalDataInputDescription;
